import { render, staticRenderFns } from "./RFPDetailsReview.vue?vue&type=template&id=86c8cc40"
import script from "./RFPDetailsReview.vue?vue&type=script&lang=js"
export * from "./RFPDetailsReview.vue?vue&type=script&lang=js"
import style0 from "./RFPDetailsReview.vue?vue&type=style&index=0&id=86c8cc40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports